module.exports = __webpack_public_path__ + "img/logo.9f23ab73.svg";